import { render, staticRenderFns } from "./VipPage.vue?vue&type=template&id=a28bfeda&scoped=true"
import script from "./VipPage.vue?vue&type=script&lang=js"
export * from "./VipPage.vue?vue&type=script&lang=js"
import style0 from "./VipPage.vue?vue&type=style&index=0&id=a28bfeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28bfeda",
  null
  
)

export default component.exports